import { useState } from 'react';
import type { OemContext } from '../../lib/auth';
import { request } from '../../lib/oem-client';
import { scopedPendingOperations, settleOperationsMutation } from '../../lib/operations-pending';
/** Read committed outcomes by exact actor/project/key after reload; never resubmit from storage. */
export function OperationsRecovery({
  context,
  userId,
  onRecovered,
}: {
  context: OemContext;
  userId: string;
  onRecovered: () => Promise<void>;
}) {
  const [message, setMessage] = useState(''),
    [busy, setBusy] = useState(false);
  async function recover() {
    setBusy(true);
    try {
      if (!navigator.onLine) throw Error('online_required');
      const rows = scopedPendingOperations(sessionStorage, {
        actorId: userId,
        organizationId: context.organizationId,
        projectId: context.projectId,
      });
      let committed = 0,
        absent = 0;
      for (const r of rows) {
        if (r.scope.action.startsWith('customer_received:')) continue;
        const outcome = await request(
          `/operations/${context.organizationId}/${context.projectId}/receipts/${r.key}`,
        );
        if (outcome && typeof outcome === 'object' && 'id' in outcome) {
          settleOperationsMutation(sessionStorage, r.scope, r.key);
          committed++;
        } else if (outcome === null) {
          settleOperationsMutation(sessionStorage, r.scope, r.key);
          absent++;
        }
      }
      await onRecovered();
      setMessage(
        committed
          ? `พบผลที่บันทึกแล้ว ${committed} รายการ · โหลดทะเบียนแล้ว`
          : absent
            ? `ยืนยันว่า ${absent} รายการยังไม่มีการบันทึก · แก้ไขข้อมูลแล้วส่งใหม่ได้`
            : 'ยังไม่พบผลที่ยืนยันได้ · ใช้ข้อมูลเดิมและสิทธิ์เดิมลองอีกครั้ง ห้ามเปลี่ยนคำสั่งที่ผลยังไม่แน่นอน',
      );
    } catch {
      setMessage('ยังอ่านผลไม่ได้ · คงรหัสเดิมไว้เพื่อลองใหม่เมื่อเชื่อมต่อและมีสิทธิ์');
    } finally {
      setBusy(false);
    }
  }
  return (
    <section className="card">
      <h2>ผลที่รอยืนยันหลังการเชื่อมต่อขาด</h2>
      <p>เก็บเพียงรหัสคำสั่งและ hash ในแท็บนี้ · กู้ผลเดิมหลังโหลดหน้าใหม่ ไม่ส่งคำสั่งอัตโนมัติ</p>
      <button className="action secondary" disabled={busy} onClick={() => void recover()}>
        กู้ผลคำสั่งที่รอยืนยัน
      </button>
      <p role="status">{message}</p>
    </section>
  );
}
